import {
  getVerificationMasterAction,
  getVerificationDataAction,
  getRejectDataAction,
} from "./action";

const initialState = {
  verificationData: "",
  verificationDetails: "",
  rejectDetails: "",
  error: "",
};

const verificationMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case getVerificationMasterAction.GET_VERIFICATION_MASTER_DETAILS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case getVerificationDataAction.GET_VERIFICATION_ALL_DETAILS_SUCCESS:
      return {
        ...state,
        verificationDetails: action.payload,
      };
    case getVerificationDataAction.GET_VERIFICATION_ALL_DETAILS_ERROR:
      return {
        ...state,
        verificationDetails: "",
        error: "",
      };
    case getRejectDataAction.GET_REJECT_DETAILS_SUCCESS:
      return {
        ...state,
        rejectDetails: action.payload,
      };
    case getRejectDataAction.GET_REJECT_DETAILS_ERROR:
      return {
        ...state,
        rejectDetails: "",
        error: "",
      };
    default:
      return state;
  }
};

export default verificationMasterReducer;
